import { FunctionComponent } from 'react';

import { useGetTicketsQuery } from '@starjack/entities/ticket';
import { Customer } from '@/models/customer';
import { usePagination } from '@starjack/shared-components';
import { TicketsOverviewUI } from '@starjack/entities/ticket';
import { useGetLiftOperatorsQuery } from '@/api/v2/liftOperator';
import { useTranslation } from 'react-i18next';

type CustomerTicketsTableProps = {
    customer: Customer;
};

export const CustomerTicketsTable: FunctionComponent<
    CustomerTicketsTableProps
> = ({ customer }) => {
    const { i18n } = useTranslation();
    const { data, isLoading, error } = useGetTicketsQuery({
        userId: customer.id,
        size: 100,
    });
    const { data: liftOperators } = useGetLiftOperatorsQuery();

    const { currentItems, setNextPage, setItemsPerPage } = usePagination({
        items: data?.content || [],
        itemsPerPage: 5,
    });

    return (
        <TicketsOverviewUI
            currentPageTickets={currentItems}
            ticketsTotal={data?.totalElements || 0}
            ticketsPerPage={5}
            onPageSizeChange={(nextValue) => {
                setItemsPerPage(nextValue);
            }}
            onPageChange={(nextValue) => {
                setNextPage(nextValue);
            }}
            hideColumns={['liftOperator']}
            hideDetailFields={['liftOperator']}
            ticketsLoading={isLoading}
            error={error}
            liftOperators={liftOperators}
            locale={i18n.language}
            translations={{
                de: i18n.store.data.de.translations as Record<string, string>,
                en: i18n.store.data.en.translations as Record<string, string>,
            }}
        />
    );
};
